/* eslint-disable */
import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import showformmodel from "../showformmodel/showformmodel.vue"
export default {
  components: {
    VPagination,
    showformmodel
  },
  data() {
    return {
      showform:false,
      currentform:"",
      currentformstatus:"",
      templatelistobj: {},
      studylist:{},
      roleprivileges: "",
      formsbylanguage:{},
      baseapi: process.env.VUE_APP_Service_URL,

    };
  },

  async mounted() {
    this.liststudy();
    await this.setroleprivileges();
    this.investigatorEmail = jwt_decode(store.getters.getIdToken);
     window.addEventListener("studyIdChanged", async () => {
       this.liststudy();
    });
  },
  methods: {
   
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
      
    },

    async closeformModal(){
      this.showform = false;
    },

    async gotofrom(formid) {
      this.currentform = formid;
      this.currentformstatus ="not completed";
      this.showform = true;
    },

     async liststudy() {
      let studyId = store.getters.getStudyIs
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseapi}/management/study/getbyid?id=${studyId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.studylist = res.data;
          var cb = document.getElementById('studyliststudyId');
              if (cb) {
                cb.checked = false;
              }
        })
        .catch((err) => console.log(" error in getting visit forms...", err));
    },

    async getlanguages(sourceTemplateId, templateName) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseapi}/forms/template/getlanguagebystudyid?sourceTemplateId=${sourceTemplateId}&templateName=${templateName}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          const raw = res.data;
    const grouped = raw.reduce(function(acc, item) {
      var key = item.language.trim().toLowerCase();
      var display = key.charAt(0).toUpperCase() + key.slice(1);
      var bucket = acc.find(function(g) { return g.Language === display; });
      if (!bucket) {
        bucket = { Language: display, Data: [] };
        acc.push(bucket);
      }
      bucket.Data.push(item);
      return acc;
    }, []);
          this.formsbylanguage[sourceTemplateId] = grouped;
          console.log("this.formsbylanguage[sourceTemplateId] = ",this.formsbylanguage[sourceTemplateId]);
        })
        .catch((err) => console.log(" error in getting visit forms...", err));
    },

    async listtemplate(studyid) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseapi}/forms/template/listtemplate?StudyID=${studyid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.templatelistobj[studyid] = res.data.results;
        })
        .catch((err) => console.log(" error in getting visit forms...", err));
    },
    // async viewForm(formId, isPatientVisit) {
    //   this.$router.push(`/editForm/submitForm/${formId}/${isPatientVisit}`);
    // },

  },
};
